import { SVGProps } from 'react';

const IcChange = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.46552 4.46357C5.21117 3.71792 6.13192 3.25778 7.09504 3.08134L6.85478 1.76984C5.63403 1.99347 4.46576 2.57771 3.52271 3.52076C1.04939 5.99408 1.04939 10.0041 3.52271 12.4774L2.38464 13.6155H5.6036V10.3966L4.46552 11.5346C2.5129 9.58202 2.5129 6.41619 4.46552 4.46357ZM13.6163 2.38387H10.3973V5.60282L11.5354 4.46475C13.488 6.41737 13.488 9.5832 11.5354 11.5358C10.7898 12.2815 9.86901 12.7416 8.90589 12.918L9.14615 14.2295C10.3669 14.0059 11.5352 13.4217 12.4782 12.4786C14.9515 10.0053 14.9515 5.99526 12.4782 3.52194L13.6163 2.38387Z'
        fill='#008BFF'
      />
    </svg>
  );
};

export default IcChange;
